export const calculateDateRange = (value) => {
  const today = new Date();
  let firstDay = new Date(today);
  let lastDay = new Date(today);

  const formatDate = (date) => {
    if (!date) return "";
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
  };

  if (value === "All Time") return { from: "", to: "" };

  switch (value) {
    case "Tomorrow":
    case "Yesterday": {
      const offset = value === "Tomorrow" ? 1 : -1;
      firstDay.setDate(today.getDate() + offset);
      lastDay.setDate(today.getDate() + offset);
      break;
    }

    case "This Week":
    case "Next Week":
    case "Last Week": {
      const offset = value === "Next Week" ? 7 : value === "Last Week" ? -7 : 0;
      const startOfWeek = today.getDate() - today.getDay() + offset;
      firstDay = new Date(today.getFullYear(), today.getMonth(), startOfWeek);
      lastDay = new Date(
        today.getFullYear(),
        today.getMonth(),
        startOfWeek + 6,
      );
      break;
    }

    case "This Month":
    case "Next Month":
    case "Last Month": {
      const offset =
        value === "Next Month" ? 1 : value === "Last Month" ? -1 : 0;
      firstDay = new Date(today.getFullYear(), today.getMonth() + offset, 1);
      lastDay = new Date(today.getFullYear(), today.getMonth() + offset + 1, 0);
      break;
    }

    case "This Year":
      firstDay = new Date(today.getFullYear(), 0, 1);
      lastDay = new Date(today.getFullYear(), 11, 31);
      break;

    case "Today":
    default:
      break;
  }

  return {
    from: formatDate(firstDay),
    to: formatDate(lastDay),
  };
};
